export const tr = {
    'no-phrases-for-replace': 'Değiştirilecek sözcük grubu bulunamadı'
};
